export const CheckingStatus = {
  idle: 'idle',
  inProgress: 'inProgress',
}
export type CheckingStatus = (typeof CheckingStatus)[keyof typeof CheckingStatus]

export const NotchState = {
  peeking: 'peeking',
  shown: 'shown',
  hidden: 'hidden',
}
export type NotchState = (typeof NotchState)[keyof typeof NotchState]
